module.exports = __webpack_public_path__ + "ipetbooking-build/img/pattern-1.2fbb4919.svg";